import { Environment } from '@transfora/core';

export const environment: Environment = {
  production: true,
  apiUrl: '#{AAWApiUrl}',
  change_password_uri: '#{AAWIdpUrl}/Account/ChangePassword',
  post_logout_redirect_uri_signin_as: '#{AAWAdminUrl}/sign-in-as',
  portal_uri : '#{AAWPortalUrl}',
  openIdConnect: {
    authority: '#{AAWIdpUrl}',
    client_id: 'aaw-admin',
    redirect_uri: '#{AAWAdminUrl}/auth-callback.html',
    scope: 'openid profile transfora-services',
    response_type: 'code',
    post_logout_redirect_uri: '#{AAWAdminUrl}',
    automaticSilentRenew: true,
    loadUserInfo: true,
    popup_redirect_uri: '#{AAWAdminUrl}/auth-popup-callback.html'
  }
};

export const appEnvironmentUri = {
  portalAppUri: '#{AAWPortalUrl}/inbox?lang='
};
